import { enumPermissionModules as EPM, enumPermissions as EP } from "../enums/authorization";

const en = {
  MenuSegment: {
    admin: 'Admin',
    user: 'User',
    system: 'System'
  },
  MenuLink: {
    homeAdmin: 'Home',
    homeUser: 'Home',
    profileAdmin: 'Profile',
    profileUser: 'Profile',
    loginHistory: 'Login History',
    logout: 'Log out',
    settingsUser: 'Settings',
    settingsAdmin: 'Settings',
    users: 'Users',
    domain: 'Domains',
    feed: 'Feed',
    feedFlow: 'Feed Flow',
    partners: 'Partners',
    campaigns: 'Campaigns',
    payment: 'Payments',
    newsletter: 'Newsletters',
    newsletterList: 'List',
    newsletterAssets: 'Assets',
    newsletterTemplate: 'Template',
    tickets: 'Tickets',
    dashboard: 'Dashboard',
    dashboardRealtime: 'Real Time',
    dashboardOverview: 'Overview',
    dashboardCountry: 'Countries',
    dashboardCampaign: 'Campaigns',
    dashboardDevice: 'Devices',
    dashboardDay: 'Days',
    statsReport: 'Report',
    bi: 'BI',
    biRequest: 'Requests',
    biKeyword: 'Keywords',
    logs: 'Logs',
    logsReport: 'Report',
    logsRequest: 'Request',
    logsQueueEmail: 'Queued Emails',

    documentation: 'Documentation',
    documentationApi: 'Api',
  },
  PermissionsModalBody: {
    admin: 'Admin',
    // Admin - Dashboard
    [EPM.ADMIN_DASHBOARD]: 'Dashboard',
    [EP.ADMIN_DASHBOARD_OVERVIEW]: 'Overview',
    [EP.ADMIN_DASHBOARD_REALTIME]: 'Realtime',
    // Admin - Stats
    [EPM.ADMIN_STATS]: 'Stats',
    [EP.ADMIN_STATS_BALANCE]: 'Balance',
    [EP.ADMIN_STATS_REPORT]: 'Report',
    // Admin - BI
    [EPM.ADMIN_BI]: 'BI',
    [EP.ADMIN_BI_SUM_REQUEST_BY_DATE]: 'Requests',
    [EP.ADMIN_BI_KEYWORDS_ANALYTICS]: 'Keywords',
    // Admin - Logs
    [EPM.ADMIN_LOGS]: 'Logs',
    [EP.ADMIN_LOGS_REPORT]: 'Report',
    [EP.ADMIN_LOGS_REQUEST]: 'Request',
    [EP.ADMIN_LOGS_QUEUE_EMAIL]: 'Queued Emails',
    // Admin - Users
    [EPM.ADMIN_USERS]: 'Users',
    [EP.ADMIN_USERS_LIST]: 'List',
    [EP.ADMIN_USERS_GET]: 'Get',
    [EP.ADMIN_USERS_CREATE]: 'Create',
    [EP.ADMIN_USERS_UPDATE]: 'Update',
    [EP.ADMIN_USERS_DELETE]: 'Delete',
    [EP.ADMIN_USERS_VALIDATE]: 'Validate',
    // Admin - Permissions
    [EPM.ADMIN_PERMISSION]: 'Permission',
    [EP.ADMIN_PERMISSION_GET]: 'Get',
    [EP.ADMIN_PERMISSION_UPDATE]: 'Update',
    // Admin - Partners
    [EPM.ADMIN_PARTNERS]: 'Partners',
    [EP.ADMIN_PARTNERS_LIST]: 'List',
    [EP.ADMIN_PARTNERS_GET]: 'Get',
    [EP.ADMIN_PARTNERS_CREATE]: 'Create',
    [EP.ADMIN_PARTNERS_UPDATE]: 'Update',
    [EP.ADMIN_PARTNERS_DELETE]: 'Delete',
    // Admin - Domains
    [EPM.ADMIN_DOMAIN]: 'Domains',
    [EP.ADMIN_DOMAIN_LIST]: 'List',
    [EP.ADMIN_DOMAIN_GET]: 'Get',
    [EP.ADMIN_DOMAIN_CREATE]: 'Create',
    [EP.ADMIN_DOMAIN_UPDATE]: 'Update',
    [EP.ADMIN_DOMAIN_DELETE]: 'Delete',
    // Admin - Feed
    [EPM.ADMIN_FEED]: 'Feed',
    [EP.ADMIN_FEED_LIST]: 'List',
    [EP.ADMIN_FEED_GET]: 'Get',
    [EP.ADMIN_FEED_CREATE]: 'Create',
    [EP.ADMIN_FEED_UPDATE]: 'Update',
    [EP.ADMIN_FEED_DELETE]: 'Delete',
    // Admin - Feed Flow
    [EPM.ADMIN_FEED_FLOW]: 'Feed Flow',
    [EP.ADMIN_FEED_FLOW_LIST]: 'List',
    [EP.ADMIN_FEED_FLOW_GET]: 'Get',
    [EP.ADMIN_FEED_FLOW_CREATE]: 'Create',
    [EP.ADMIN_FEED_FLOW_UPDATE]: 'Update',
    [EP.ADMIN_FEED_FLOW_DELETE]: 'Delete',
    // Admin - Campaigns
    [EPM.ADMIN_CAMPAIGNS]: 'Campaigns',
    [EP.ADMIN_CAMPAIGNS_LIST]: 'List',
    [EP.ADMIN_CAMPAIGNS_GET]: 'Get',
    [EP.ADMIN_CAMPAIGNS_CREATE]: 'Create',
    [EP.ADMIN_CAMPAIGNS_UPDATE]: 'Update',
    [EP.ADMIN_CAMPAIGNS_DELETE]: 'Delete',
    // Admin - Campaigns Audience
    [EPM.ADMIN_CAMPAIGNS_AUDIENCE]: 'Campaigns Audience',
    [EP.ADMIN_CAMPAIGNS_AUDIENCE_GET]: 'Get',
    [EP.ADMIN_CAMPAIGNS_AUDIENCE_UPDATE]: 'Update',
    // Admin - Campaigns Rules
    [EPM.ADMIN_CAMPAIGNS_RULES]: 'Campaigns Rules',
    [EP.ADMIN_CAMPAIGNS_RULES_LIST]: 'List',
    [EP.ADMIN_CAMPAIGNS_RULES_GET]: 'Get',
    [EP.ADMIN_CAMPAIGNS_RULES_CREATE]: 'Create',
    [EP.ADMIN_CAMPAIGNS_RULES_UPDATE]: 'Update',
    [EP.ADMIN_CAMPAIGNS_RULES_DELETE]: 'Delete',
    // Admin - Payments
    [EPM.ADMIN_PAYMENT]: 'Payment',
    [EP.ADMIN_PAYMENT_LIST]: 'List',
    [EP.ADMIN_PAYMENT_GET]: 'Get',
    [EP.ADMIN_PAYMENT_CREATE]: 'Create',
    [EP.ADMIN_PAYMENT_UPDATE]: 'Update',
    [EP.ADMIN_PAYMENT_DELETE]: 'Delete',
    // Admin - Newsletter List
    [EPM.ADMIN_NEWSLETTER]: 'Newsletter',
    [EP.ADMIN_NEWSLETTER_LIST]: 'List',
    [EP.ADMIN_NEWSLETTER_GET]: 'Get',
    [EP.ADMIN_NEWSLETTER_CREATE]: 'Create',
    [EP.ADMIN_NEWSLETTER_UPDATE]: 'Update',
    [EP.ADMIN_NEWSLETTER_DELETE]: 'Delete',
    // Admin - Newsletter Assets
    [EPM.ADMIN_NEWSLETTER_ASSETS]: 'Newsletter Assets',
    [EP.ADMIN_NEWSLETTER_ASSETS_LIST]: 'List',
    [EP.ADMIN_NEWSLETTER_ASSETS_GET]: 'Get',
    [EP.ADMIN_NEWSLETTER_ASSETS_CREATE]: 'Create',
    [EP.ADMIN_NEWSLETTER_ASSETS_UPDATE]: 'Update',
    [EP.ADMIN_NEWSLETTER_ASSETS_DELETE]: 'Delete',
    // Admin - Newsletter Template
    [EPM.ADMIN_NEWSLETTER_TEMPLATE]: 'Newsletter Template',
    [EP.ADMIN_NEWSLETTER_TEMPLATE_LIST]: 'List',
    [EP.ADMIN_NEWSLETTER_TEMPLATE_GET]: 'Get',
    [EP.ADMIN_NEWSLETTER_TEMPLATE_CREATE]: 'Create',
    [EP.ADMIN_NEWSLETTER_TEMPLATE_UPDATE]: 'Update',
    [EP.ADMIN_NEWSLETTER_TEMPLATE_DELETE]: 'Delete',
    // Admin - Login history
    [EPM.ADMIN_LOGIN_HISTORY]: 'Login History',
    [EP.ADMIN_LOGIN_HISTORY_LIST]: 'List',
    // Admin - Profile
    [EPM.ADMIN_PROFILE]: 'Profile',
    [EP.ADMIN_PROFILE_GET]: 'Get',
    [EP.ADMIN_PROFILE_UPDATE]: 'Update',
    // Admin - Country
    [EPM.ADMIN_COUNTRY]: 'Country',
    [EP.ADMIN_COUNTRY_LIST]: 'List',


    common: 'Common',
    // Settings
    [EPM.SETTINGS]: 'Settings',
    [EP.SETTINGS_GET]: 'Get',
    [EP.SETTINGS_UPDATE]: 'Update',


    // Admin - Tickets
    [EPM.ADMIN_TICKETS]: 'Tickets',
    [EP.ADMIN_TICKETS_LIST]: 'List',
    [EP.ADMIN_TICKETS_GET]: 'Get',
    [EP.ADMIN_TICKETS_DELETE]: 'Delete',
    [EP.ADMIN_TICKETS_REPLY]: 'Reply',
    [EP.ADMIN_TICKETS_STATUS]: 'Status',
  },
  DashboardFooter: {
    companyName: 'MONETIZEAD',
    craftedLeft: 'Crafted with',
    craftedRight: 'by MonetizeAd'
  },
  Logout: {
    title: 'Logout',
    loading: 'Waiting to safely log out',
    completed: 'You have been safely logged out',
    button: 'Back to Login'
  }

}

export default en;